import React from 'react';

export const MissionVisionValues: React.FC = () => {
  return (
    <div className="mvv-section">
      <div className="mvv-header">
        <h2>🎯 Our Foundation</h2>
      </div>
      
      <div className="mvv-content">
        {/* Vision */}
        <div className="mvv-card vision-card">
          <div className="mvv-card-header">
            <span className="mvv-icon">🔭</span>
            <h3>VISION</h3>
          </div>
          <div className="mvv-card-body">
            <h4>"Be the Heroes of Home Comfort: Swift, Reliable, and Unmatched"</h4>
            <p>
              Our vision is to be the ultimate solution for heating, cooling, and plumbing needs. 
              We aspire to redefine home services by setting a gold standard in speed, quality, and 
              customer experience. With unmatched responsiveness and expert care, we aim to save the 
              day for every customer, every time.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="mvv-card mission-card">
          <div className="mvv-card-header">
            <span className="mvv-icon">🎯</span>
            <h3>MISSION</h3>
          </div>
          <div className="mvv-card-body">
            <h4>"Saving the Day, Every Day: Your Comfort is Our Call to Action"</h4>
            <p>
              Our mission embodies the spirit of swift and decisive action, ensuring comfort and peace 
              of mind for every customer. We're dedicated to being the heroes our customers deserve by 
              doing the right things, in the right way, without delay. This approach creates wins for 
              everyone: our customers, our team, and the communities we serve.
            </p>
            <p>
              We aim to be the first and most trusted choice for home service needs, delivering an 
              exceptional experience defined by:
            </p>
            <ul className="mvv-list">
              <li><strong>Empathy</strong> by listening and understanding your concerns as if they were our own.</li>
              <li><strong>Speed and Precision</strong> by acting quickly and effectively to resolve issues.</li>
              <li><strong>Accountability</strong> by taking full ownership of outcomes and ensuring your satisfaction.</li>
            </ul>
            <p>
              At Right Away Home Services, we're powered by a culture of excellence, driven by integrity, 
              skill, and purpose. Our team is constantly evolving to meet and exceed your expectations, 
              guaranteeing every job we do. We're available 24/7/365, ready to answer the call whenever 
              you need us—because your comfort can't wait.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mvv-card values-card">
          <div className="mvv-card-header">
            <span className="mvv-icon">⭐</span>
            <h3>VALUES</h3>
          </div>
          <div className="mvv-card-body">
            <h4>"Integrity, Respect, and Heroic Teamwork: The Core of Our Service"</h4>
            <p>
              Our values define the heart of our 'Right Away' promise, empowering us to deliver 
              heroic service every day:
            </p>
            <ul className="mvv-list">
              <li>
                <strong>Respect for Time and Privacy:</strong> We treat every home with care, 
                safeguarding your time and personal space with respect.
              </li>
              <li>
                <strong>Heroic Teamwork and Safety:</strong> Our team works together seamlessly, 
                adhering to the highest safety standards to ensure exceptional outcomes.
              </li>
              <li>
                <strong>Unshakable Integrity:</strong> Every decision we make is guided by honesty 
                and a commitment to acting in your best interest.
              </li>
            </ul>
            <p className="mvv-closing">
              With every action, we aim to be the dependable heroes who bring comfort, safety, and 
              reliability to your home.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
